module.exports = __webpack_public_path__ + "media/images/area/sub_hero_map_kansai-d64dc15fe7f0d11f96bb38b22e4f3988.png";